export default __webpack_public_path__ + "static/media/board_disabled.d71fdc49.svg";